import { Fragment, useCallback, useMemo, useState } from "react";

import { EmbedDialog } from "components/dialogs";
import { PopOverMenu } from "components/UI/PopOverMenu";
import { getShareMenuItems } from "./data";
import { metrics } from "utils/metrics";
import fscreen from "fscreen";
import "./ShareMenu.scss";

interface IShareMenuProps {
  anchorEl: HTMLElement | null;
  onClick: (label: string) => void;
  onClose: () => void;
  fixedEmbedCode: string;
  responsiveEmbedCode: string;
  fullscreen?: boolean;
}

export const ShareMenu = (props: IShareMenuProps) => {
  const {
    anchorEl,
    onClick,
    onClose,
    fixedEmbedCode,
    responsiveEmbedCode,
    fullscreen = false
  } = props;

  const [shareOpen, setShareOpen] = useState<boolean>(true);
  const [embedOpen, setEmbedOpen] = useState<boolean>(false);

  const handleEmbedOpen = useCallback(() => {
    setEmbedOpen(true);
    setShareOpen(false);
  }, []);

  const handleClick = useCallback((label: string) => {
    if (label === "Embed") {
      handleEmbedOpen();
      metrics.sendShareEmbed();
      return;
    }

    onClick(label);
  }, [handleEmbedOpen, onClick]);

  const menuItems = useMemo(() => {
    return getShareMenuItems(handleClick);
  }, [handleClick]);

  const isFullscreenActive = fscreen.fullscreenElement;

  return (
    <Fragment>
      {
        shareOpen && <PopOverMenu
          className="ShareMenu"
          title="Share"
          menuProps={{
            anchorEl,
            anchorOrigin: {
              vertical: "center",
              horizontal: !isFullscreenActive ? "right" : "left",
            },
            transformOrigin: {
              vertical: "center",
              horizontal: !isFullscreenActive ? "left" : "right",
            },
            container: fscreen.fullscreenElement || undefined
          }}
          isOpen={true}
          onClose={onClose}
          menuItems={menuItems}
          isFullscreen={fullscreen}
        />
      }

      <EmbedDialog
        isOpen={embedOpen}
        onClose={onClose}
        fixedEmbedCode={fixedEmbedCode}
        responsiveEmbedCode={responsiveEmbedCode}
      />
    </Fragment>
  );
};
